var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "message-item" }, [
        _c(
          "div",
          { staticClass: "message-item-inner p-3 my-1" },
          [
            _c("header", [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-justify-content-space-between is-align-items-center",
                  },
                  [
                    _vm._m(0),
                    _c(
                      "div",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "toggleButton is-rounded ml-2",
                            attrs: {
                              size: "is-small",
                              "aria-controls": "param-2",
                              "aria-expanded": _vm.isOpen2,
                            },
                            on: {
                              click: function ($event) {
                                _vm.isOpen2 = !_vm.isOpen2
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fas",
                              class: {
                                "fa-angle-down": !_vm.isOpen2,
                                "fa-angle-up": _vm.isOpen2,
                              },
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
            _c(
              "b-collapse",
              {
                staticClass: "message-body is-size-7",
                attrs: {
                  open: _vm.isOpen2,
                  "aria-id": "param-2",
                  animation: "slide",
                },
              },
              [
                _c("div", { staticClass: "content mt-3 p-4" }, [
                  (_vm.operation.remaining?.prepaidFee &&
                    _vm.isPrepaidDateValid) ||
                  _vm.isUpdateNewDate
                    ? _c("div", { staticClass: "mb-0 is-flex" }, [
                        _c("div", { staticClass: "prepaid-column" }, [
                          _vm.isUpdateNewDate
                            ? _c(
                                "div",
                                [
                                  _c("b-skeleton", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      width: "60%",
                                      animated: _vm.animated,
                                    },
                                  }),
                                  _c("b-skeleton", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      width: "60%",
                                      animated: _vm.animated,
                                    },
                                  }),
                                  _c("b-skeleton", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      width: "60%",
                                      animated: _vm.animated,
                                    },
                                  }),
                                  _c("b-skeleton", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      width: "60%",
                                      animated: _vm.animated,
                                    },
                                  }),
                                  _c("b-skeleton", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      width: "60%",
                                      animated: _vm.animated,
                                    },
                                  }),
                                  _c("b-skeleton", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      width: "60%",
                                      animated: _vm.animated,
                                    },
                                  }),
                                  _c("b-skeleton", {
                                    staticClass: "ml-1",
                                    attrs: {
                                      width: "60%",
                                      animated: _vm.animated,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("div", [
                                _c(
                                  "p",
                                  [
                                    _vm._v(" Data: "),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          type: "is-light is-primary",
                                          size: "is-small",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.operation.remaining?.prepaidDate
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  [
                                    _vm._v(" Valor da parcela pendente: "),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          type: "is-light is-primary",
                                          size: "is-small",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.operation.remaining
                                                ?.remainingTotalPayments
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  [
                                    _vm._v(" Saldo da última parcela: "),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          type: "is-light is-primary",
                                          size: "is-small",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.operation.remaining
                                                ?.remainingBalance
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  [
                                    _vm._v(" Proporção da última parcela: "),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          type: "is-light is-primary",
                                          size: "is-small",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.operation.remaining
                                              ?.inflationProportional
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  [
                                    _vm._v(" IPCA proporcional: "),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          type: "is-light is-primary",
                                          size: "is-small",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.operation.remaining
                                                ?.proportionalIpcaUpate
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  [
                                    _vm._v(" Juros proporcionais: "),
                                    _vm.isUpdateNewDate
                                      ? _c("b-skeleton", {
                                          attrs: {
                                            width: "30%",
                                            animated: _vm.animated,
                                          },
                                        })
                                      : _vm._e(),
                                    _c(
                                      "b-tag",
                                      {
                                        staticClass: "ml-1",
                                        attrs: {
                                          type: "is-light is-primary",
                                          size: "is-small",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.operation.remaining
                                                ?.proportionalInterestIUB
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "p",
                                  [
                                    _vm._v(
                                      " Seguro total da próxima parcela: "
                                    ),
                                    _c(
                                      "b-tag",
                                      {
                                        attrs: {
                                          type: "is-light is-primary",
                                          size: "is-small",
                                          rounded: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.operation.remaining
                                                ?.totalInsurancesNextDebtPayment
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                        ]),
                        _c("div", { staticClass: "prepaid-column" }, [
                          _c("div", { staticClass: "card-item shadowless" }, [
                            _c(
                              "p",
                              { staticClass: "has-text-weight-bold" },
                              [
                                _vm._v(" Custo pré-pago:"),
                                _c("br"),
                                _vm.isUpdateNewDate
                                  ? _c("b-skeleton", {
                                      attrs: {
                                        width: "30%",
                                        animated: _vm.animated,
                                      },
                                    })
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "has-text-primary is-size-5",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.operation.remaining
                                                ?.prepaidFee
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : !_vm.isUpdateNewDate
                    ? _c(
                        "div",
                        [
                          _vm.isPrepaidDateValid
                            ? _c(
                                "b-notification",
                                {
                                  staticClass: "my-1",
                                  attrs: {
                                    type: "is-danger is-light",
                                    "data-cy": "resume-company-operation-id",
                                    closable: false,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-solid fa-triangle-exclamation",
                                  }),
                                  _vm._v(
                                    " O custo do pré-pagamento não pode ser demonstrado porque o valor do IPCA nesta data não está disponível. "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          !_vm.isPrepaidDateValid
                            ? _c(
                                "b-notification",
                                {
                                  staticClass: "my-1",
                                  attrs: {
                                    type: "is-danger is-light",
                                    "data-cy": "resume-company-operation-id",
                                    closable: false,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-solid fa-triangle-exclamation",
                                  }),
                                  _vm._v(
                                    " O custo do pré-pagamento de uma data anterior não pode ser exibido. "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "message-item last-message" }, [
        _c(
          "div",
          { staticClass: "message-item-inner p-3 my-1" },
          [
            _c("header", [
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "is-flex is-justify-content-space-between is-align-items-center",
                  },
                  [
                    _vm._m(1),
                    _c(
                      "div",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "toggleButton is-rounded ml-2",
                            attrs: {
                              size: "is-small",
                              "aria-controls": "param-1",
                              "aria-expanded": _vm.isOpen,
                            },
                            on: {
                              click: function ($event) {
                                _vm.isOpen = !_vm.isOpen
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fas",
                              class: {
                                "fa-angle-down": !_vm.isOpen,
                                "fa-angle-up": _vm.isOpen,
                              },
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
            _c(
              "b-collapse",
              {
                staticClass: "message-body is-size-7",
                attrs: {
                  open: _vm.isOpen,
                  "aria-id": "notification",
                  animation: "slide",
                },
              },
              [
                _c("div", { staticClass: "content mt-3 p-4" }, [
                  _c("div", { staticClass: "mb-0" }, [
                    _c("div", [
                      !_vm.resultsView
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "input-fields" },
                              [
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: "Parcela inicial",
                                      type: _vm.fields.firstPayment.type,
                                      message: _vm.fields.firstPayment.message,
                                    },
                                  },
                                  [
                                    _c("b-numberinput", {
                                      attrs: {
                                        id: "input-first-payment",
                                        placeholder: _vm.minPaymentNumber,
                                        step: "1",
                                        min: _vm.minPaymentNumber,
                                        max: _vm.maxPaymentNumber,
                                        "controls-position": "compact",
                                        expanded: false,
                                      },
                                      on: { input: _vm.verifyFields },
                                      model: {
                                        value: _vm.fields.firstPayment.number,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fields.firstPayment,
                                            "number",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "fields.firstPayment.number",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: "Parcela final",
                                      type: _vm.fields.lastPayment.type,
                                      message: _vm.fields.lastPayment.message,
                                    },
                                  },
                                  [
                                    _c("b-numberinput", {
                                      attrs: {
                                        id: "input-last-payment",
                                        placeholder: _vm.maxPaymentNumber,
                                        step: "1",
                                        min: _vm.minPaymentNumber,
                                        max: _vm.maxPaymentNumber,
                                        "controls-position": "compact",
                                        expanded: false,
                                      },
                                      on: { input: _vm.verifyFields },
                                      model: {
                                        value: _vm.fields.lastPayment.number,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fields.lastPayment,
                                            "number",
                                            $$v
                                          )
                                        },
                                        expression: "fields.lastPayment.number",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-field",
                                  {
                                    attrs: {
                                      label: "CAP (%)",
                                      type: _vm.fields.newInflationaryUpperBound
                                        .type,
                                      message:
                                        _vm.fields.newInflationaryUpperBound
                                          .message,
                                    },
                                  },
                                  [
                                    _c("b-numberinput", {
                                      attrs: {
                                        id: "input-upper-bound",
                                        placeholder:
                                          _vm.fields.newInflationaryUpperBound
                                            .number,
                                        step: "0.1",
                                        min: "0",
                                        "min-step": "0.01",
                                        "icon-right": "percentage",
                                        "controls-position": "compact",
                                        expanded: false,
                                      },
                                      on: { input: _vm.verifyFields },
                                      model: {
                                        value:
                                          _vm.fields.newInflationaryUpperBound
                                            .number,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fields
                                              .newInflationaryUpperBound,
                                            "number",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "fields.newInflationaryUpperBound.number",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "buttons" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-primary is-rounded",
                                  attrs: {
                                    id: "apply-button",
                                    disabled: _vm.buttonIsDisabled,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showConfirmModal()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("applyButton")) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button is-button-primary-light is-rounded",
                                  attrs: { id: "cancel-button" },
                                  on: { click: _vm.cancelChanges },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("cancelButton")) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _c("div", [
                            _vm.changesResult.error
                              ? _c(
                                  "div",
                                  [
                                    _vm.changesResult.message !== ""
                                      ? _c("Message", {
                                          attrs: {
                                            message: _vm.changesResult.message,
                                            icon: _vm.changesResult.icon,
                                            "as-card": false,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("h5", [_vm._v("Resultados")]),
                                    _c(
                                      "div",
                                      { staticClass: "changes-details-header" },
                                      [
                                        _c("p", [_vm._v("N")]),
                                        _c("p", [_vm._v("CAP")]),
                                        _c("p", [_vm._v("BOLETO")]),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.changesResult.result,
                                      function (payment) {
                                        return _c(
                                          "div",
                                          {
                                            key: payment.paymentNumber,
                                            staticClass: "changes-details",
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(payment.paymentNumber)
                                              ),
                                            ]),
                                            payment.previousInflationaryUpperBound !==
                                            payment.newInflationaryUpperBound
                                              ? _c(
                                                  "b-tooltip",
                                                  {
                                                    attrs: {
                                                      label: `CAP antes de la modificación: ${(
                                                        payment.previousInflationaryUpperBound *
                                                        100
                                                      ).toFixed(2)}%`,
                                                      type: "is-light",
                                                      position: "is-top",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "had-changed",
                                                        attrs: {
                                                          id: `payment-${payment.paymentNumber}-newUpperBound`,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              (
                                                                payment.newInflationaryUpperBound *
                                                                100
                                                              ).toFixed(2)
                                                            ) +
                                                            "% "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "b-tooltip",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "CAP no fue modificado",
                                                      type: "is-light",
                                                      position: "is-top",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "had-not-changed",
                                                        attrs: {
                                                          id: `payment-${payment.paymentNumber}-newUpperBound`,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              (
                                                                payment.newInflationaryUpperBound *
                                                                100
                                                              ).toFixed(2)
                                                            ) +
                                                            "% "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                            _c(
                                              "div",
                                              [
                                                payment.newBoletoCreated
                                                  ? _c(
                                                      "b-tooltip",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "Se generó un nuevo boleto",
                                                          type: "is-light",
                                                          position: "is-top",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-solid fa-file-text had-changed",
                                                        }),
                                                      ]
                                                    )
                                                  : payment.isPaid
                                                  ? _c(
                                                      "b-tooltip",
                                                      {
                                                        attrs: {
                                                          label:
                                                            "No se cambió la tasa ni se creó un nuevo boleto porque la cuota ya se encuentra pagada",
                                                          type: "is-light",
                                                          position: "is-top",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-solid fa-file had-not-changed",
                                                        }),
                                                      ]
                                                    )
                                                  : _c(
                                                      "b-tooltip",
                                                      {
                                                        attrs: {
                                                          label:
                                                            payment.previousInflationaryUpperBound !==
                                                            payment.newInflationaryUpperBound
                                                              ? "Se cambió la tasa pero no se generó boleto porque la cuota aún no está disponible"
                                                              : "No se requirió realizar cambios",
                                                          type: "is-light",
                                                          position: "is-top",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa-solid fa-file had-not-changed",
                                                        }),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button is-button-primary is-rounded apply",
                                attrs: { id: "thanks-button" },
                                on: { click: _vm.finishChanges },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("thanksButton")) + " "
                                ),
                              ]
                            ),
                          ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("OperationModifierConfirmModal", {
        attrs: {
          "first-payment": _vm.fields.firstPayment.number,
          "last-payment": _vm.fields.lastPayment.number,
          "new-inflationary-upper-bound":
            _vm.fields.newInflationaryUpperBound.number,
          "is-component-modal-active": _vm.isComponentModalActive,
        },
        on: {
          applyInflationaryUpperBoundChanges:
            _vm.applyInflationaryUpperBoundChanges,
          cancelModal: _vm.cancelModal,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-flex is-align-items-center" }, [
      _c("div", { staticClass: "is-flex is-flex-direction-column" }, [
        _c("div", [
          _c("div", { staticClass: "is-flex is-align-items-center" }, [
            _c("p", { staticClass: "has-text-weight-medium is-size-6" }, [
              _vm._v("Custo pré-pago"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "is-flex is-align-items-center" }, [
      _c("div", { staticClass: "is-flex is-flex-direction-column" }, [
        _c("div", [
          _c("div", { staticClass: "is-flex is-align-items-center" }, [
            _c("p", { staticClass: "has-text-weight-medium is-size-6" }, [
              _vm._v("Atualizar CAP"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }